<template>
  <div class="interest_table2024" :class="[scene]">
    <template v-if="interestDetailData && interestDetailData.dataList && interestDetailData.dataList.length > 1">
      <section class="interest_table_main">
        <div
          v-for="name in tableNames"
          :key="name"
          :ref="`table_wrapper_${name}`"
          :class="['table_wrapper', name]"
          :style="['fixed_left', 'fixed_top_left'].includes(name) ? {
            width: `${(tableColumnWidthMap.year || 0) + (tableColumnWidthMap.age || 0) + (tableColumnWidthMap.age2 || 0)}em`
          } : {}"
          @scroll="handleScroll(name, $event)"
        >
          <table>
            <thead>
              <tr>
                <th
                  v-for="k in tableColumnKeys"
                  :key="k"
                  :style="{
                    width: `${tableColumnWidthMap[k]}em`,
                    minWidth: `${tableColumnWidthMap[k]}em`,
                    maxWidth: `${tableColumnWidthMap[k]}em`
                  }"
                  @click="onClickOpenExplain(k)"
                >
                  <template v-if="tableHeaderData[`__${k}__eye_icon`] || tableHeaderData[`__${k}__problem_icon`]">
                    <div class="th_wrapper">
                      <span
                        v-if="tableHeaderData[`__${k}__eye_icon`]"
                        class="th_icon_eye"
                        @click.stop="onClickEyeIcon(k)"
                      >
                        <i :class="['iconfont', hideFieldsForClient.includes(k) ? 'icon-close_eye' : 'icon-open_eye']" />
                      </span>
                      <span class="th_content" v-html="tableHeaderData[k]" />
                      <span v-if="tableHeaderData[`__${k}__problem_icon`]">
                        <i class="iconfont icon-common_problem" />
                      </span>
                    </div>
                    <span
                      v-if="tableHeaderData[`__${k}__eye_icon`] && isShowEyeTips && k === ['irr_value', 'single_value', 'remark'].find(k => !!tableHeaderData[k])"
                      class="th_eye_tips"
                    >
                      {{ hideFieldsForClient.includes(k) ? '转发不可见' : '转发可见' }}
                    </span>
                  </template>
                  <span v-else v-html="tableHeaderData[k]" />
                </th>
              </tr>
            </thead>
            <tbody v-if="['normal', 'fixed_left'].includes(name)">
              <tr
                v-for="record in tableBodyData"
                :key="record.year"
                :class="{
                  tr_border_right: record[`__${tableColumnKeys[tableColumnKeys.length - 1]}__rowspan`] === 0
                }"
              >
                <template v-for="k in tableColumnKeys">
                  <td
                    v-if="record[`__${k}__rowspan`] !== 0"
                    :key="k"
                    :class="{
                      active_color: record[`__${k}__color_flag`],
                      active_bg: record[`__${k}__bgcolor_flag`],
                      purpose_tag: tableBodyData.some(e => e[`__${k}__purpose_tag`]),
                      multiple_tag: tableBodyData.some(e => e[`__${k}__multiple_tag`]),
                      interest_ze_tag: tableBodyData.some(e => e[`__${k}__interest_ze_tag`]),
                      interest_lq_tag: tableBodyData.some(e => e[`__${k}__interest_lq_tag`]),
                      interest_lj_tag: tableBodyData.some(e => e[`__${k}__interest_lj_tag`]),
                      writing_mode: record[`__${k}__writing_mode_flag`]
                    }"
                    :style="{
                      width: `${tableColumnWidthMap[k]}em`,
                      minWidth: `${tableColumnWidthMap[k]}em`,
                      maxWidth: `${tableColumnWidthMap[k]}em`
                    }"
                    :rowspan="record[`__${k}__rowspan`] || 1"
                    v-html="record[k]"
                  />
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </template>
  </div>
</template>
<script>
import { get as _get, cloneDeep } from 'lodash'
import htmlToText from 'html-to-text'
import { URL_PARAM } from '@/common/utils'
import { isBxs } from 'base/config'
import { animate } from 'common/js/animate'
import { getBaofMultipleTag, getInterestTag } from '@/pages/planbkTemplatev2/components/interestDemo/handler'

const { familyId, app, shareFrom } = URL_PARAM
let eyeTimer = null
export default {
  props: {
    scene: {
      type: String,
      default: () => 'normal'
    },
    personData: {
      type: Object,
      default: () => ({})
    },
    productFormData: {
      type: Object,
      default: () => ({})
    },
    productInterestData: {
      type: Object,
      default: () => ({})
    },
    productResultData: {
      type: Object,
      default: () => ({})
    },
    interestDetailData: {
      type: Object,
      default: () => ({})
    },
    isScreenCaptureShow: Boolean
  },
  data () {
    return {
      isShowFixedTableHeader: null,
      isInvokeAnimation: null,
      isShowEyeTips: true,
      skipNextScroll: false // 标志当前主动触发的类型,用于跳过因手动修改scrollLeft导致的@scroll响应
    }
  },
  computed: {
    tableNames () {
      const { scene, isShowFixedTableHeader, isScreenCaptureShow } = this
      let names = ['normal', 'fixed_left']
      if (isShowFixedTableHeader && isScreenCaptureShow) {
        names.push('fixed_top', 'fixed_top_left')
      }
      if (scene === 'export') {
        names = ['normal']
      }
      return names
    },
    isAllowScroll () {
      return this.scene !== 'export'
    },
    hideFieldsForClient () {
      return _get(this, 'productFormData.formValues.hideFieldsForClient') || []
    },
    displayFields () {
      const { hideFieldsForClient } = this
      let _displayFields = _get(this.productFormData, 'formValues.displayFields') || []
      if (app || shareFrom) {
        _displayFields = _displayFields.filter(f => !hideFieldsForClient.includes(f))
      }
      return _displayFields
    },
    hasInsured2 () {
      return _get(this, 'personData.insured2Info.title') && typeof _get(this, 'personData.insured2Info.age') === 'number'
    },
    period () {
      const _mulInsOrderList = _get(this, 'productResultData.mulInsOrderList') || []
      const _insurance0 = _mulInsOrderList.find(ins => ins.key !== 'common')
      return _get(_insurance0, 'period') || 0
    },
    remarkList () {
      const { personData, productInterestData, interestDetailData } = this
      // 由于表格可以显示全部年龄，也可以只显示年龄的 remarkList 中的 startIndex、endIndex 需要转换为年龄
      // 年龄与索引的换算：i + insuredAge + startIndex  + 1
      const _insuredAge = _get(personData, 'insuredInfo.age')
      const _interestStartIndex = _get(productInterestData, 'startIndex') || 0
      const _age = _insuredAge + _interestStartIndex  + 1
      const remarkList = cloneDeep(_get(interestDetailData, 'remarkList')) || []
      remarkList.forEach(detail => {
        detail.startAge = detail.startIndex + _age
        detail.endAge = detail.endIndex + _age
      })
      return remarkList
    },
    interestDetailList () {
      const { displayFields } = this
      const _dataList = _get(this.interestDetailData, 'dataList') || []
      let _interestDetailList = []
      if (Array.isArray(_dataList)) {
        _interestDetailList = _dataList.filter(item => {
          return displayFields.includes(item.key) && (_get(item, 'values.length') || item.key === 'remark')
        })
      }
      return _interestDetailList
    },
    tableHeaderData () {
      const { scene, interestDetailList, hasInsured2 } = this
      let tableHeader = {}
      if (Array.isArray(interestDetailList)) {
        const defaultHeader = {
          year: '年度',
          age: '年龄'
        }
        if (hasInsured2) {
          defaultHeader.age = '被保人1年末年龄'
          defaultHeader.age2 = '被保人2年末年龄'
        }
        tableHeader = interestDetailList.reduce((obj, item) => {
          obj[item.key] = item.name || item.key
          if (scene !== 'export') {
            if (!!item.detail) {
              obj[`__${item.key}__problem_icon`] = true
            }
            if (isBxs && ['irr_value', 'single_value', 'remark'].includes(item.key)) {
              obj[`__${item.key}__eye_icon`] = true
            }
          }
          return obj
        }, defaultHeader)
      }
      return tableHeader
    },
    cleanTableData () {
      const { personData, productFormData, productInterestData, period, interestDetailData, interestDetailList } = this
      const _age = _get(personData, 'insuredInfo.age')
      const _age2 = _get(personData, 'insured2Info.age')
      const _period = Math.min(_get(personData, 'main.period') || period, 10)
      const _displayAge = _get(productFormData, 'formValues.displayAge')
      const _startPolicyNo = _get(productInterestData, 'startPolicyNo')
      const _startIndex = _get(productInterestData, 'startIndex')
      const _interestDetailList = interestDetailList || []

      let tableData = []
      const maxlength = _interestDetailList.reduce((a, b) => Math.max(a, b.values.length || 0), 0);
      _interestDetailList
        .filter(item => (item.values || []).length)
        .forEach((item) => {
          for (let i = 0; i < maxlength; i++) {
            tableData[i] = tableData[i] || {
              year: i + _startPolicyNo,
              age: i + _age + _startIndex  + 1,
              age2: _age2 ? i + _age2 + _startIndex  + 1 : null,
            }
            tableData[i][item.key] = item.values[i]
            if (['take', 'draw_value', 'draw_value2'].includes(item.key) && Array.isArray(item.details)) {
              tableData[i][`__${item.key}__purpose_tag`] = item.details[i] || ''
            }
          }
        })

      // 未勾选累积保费，也需要显示超保费标识
      const baofInterestDetail = (_get(interestDetailData, 'dataList') || []).find(e => ['baofei_sum', 'baof_sum'].includes(e.key))
      const baofValues = baofInterestDetail ? baofInterestDetail.values : []
      if (baofValues.length) {
        tableData.forEach((record, i) => {
          const value = baofValues[i]
          record[`__baof_divisor`] = value
        })
      }

      tableData = getBaofMultipleTag(tableData, productFormData)
      // 增加标签 交清增额、现金领取、累积生息
      tableData = getInterestTag(tableData, interestDetailData)
      if (_displayAge) {
        // 从 dataList 取首个 annuity_year 不为 0 的年度（未勾选时 tableData 中无该列）
        const dataList = _get(interestDetailData, 'dataList') || []
        const annuityYearItem = dataList.find(item => item.key === 'annuity_year')
        const annuityValues = _get(annuityYearItem, 'values') || []
        const firstIdx = annuityValues.findIndex(v => v && v !== 0 && v !== '0' && v !== '-')
        const firstAnnuityYear = firstIdx !== -1 ? firstIdx + _startPolicyNo : null
        tableData = tableData.filter((e, i, arr) => {
          const isMainRow = (i === 0) || (i === arr.length - 1) || (e.year <= _period)
          const isGapRow = ((e.age % _displayAge) === 0)
          const isFirstAnnuityYear = firstAnnuityYear && e.year === firstAnnuityYear
          return isMainRow || isGapRow || isFirstAnnuityYear
        })
      }
      return tableData
    },
    tableBodyData () {
      const { productFormData, cleanTableData, remarkList } = this
      const _displayAge = _get(productFormData, 'formValues.displayAge') || null

      const tableBodyData = cloneDeep(cleanTableData)
      // 添加备注列
      if (remarkList.some(e => e.columnKey === 'remark')) {
        remarkList
          .filter(d => d.columnKey === 'remark')
          .forEach(d => {
            const { startAge, endAge, remark, subRemark } = d
            const _record0 = tableBodyData.find(e => e.age >= startAge && e.age <= endAge)
            if (_record0) {
              _record0.remark = _displayAge ? remark : [remark, subRemark].filter(e => !!e).join('<br /><br />')
            }
          })
      }
      // 设置跨行
      remarkList
        .filter(detail => detail.columnKey !== 'title')
        .forEach(detail => {
          const { columnKey, remark, subRemark, startAge, endAge } = detail
          const records = tableBodyData.filter(e => e.age >= startAge && e.age <= endAge)
          if (records.length) {
            if (['baof'].includes(columnKey) && records.length <= 14) {
              return
            }
            records.forEach((record, i) => {
              let _recordKey = columnKey
              // remarkList 中的 baof，在 dataList 中可能是 baof 或者 baofei
              if (columnKey === 'baof' && !('baof' in record) && ('baofei' in record)) {
                _recordKey = 'baofei'
              }
              let _remark = (_displayAge ? remark : [remark, subRemark].filter(e => !!e).join('<br /><br />')) || ''

              record[`__${_recordKey}__rowspan`] = 0
              if (i === 0) {
                record[`__${_recordKey}__rowspan`] = records.length
                if (columnKey === 'baof') {
                  // 文本竖排，计算高度、文字间距
                  let _lineHeight = Math.min(16 + records.length - 14, 30)
                  _remark = _remark.split(/\s+/).map(e => `<em>${e}</em>`).join('')
                  _remark = `<span style="line-height: ${_lineHeight}px">
                    ${_remark}
                  </span>`
                  record[`__${_recordKey}__writing_mode_flag`] = true
                } else {
                  _remark = _remark.replace(/\r\n/g, '<br /><br />')
                }
                record[_recordKey] = _remark
              }
            })
          }
        })

      tableBodyData.forEach(record => {
        for (const k in record) {
          const value = record[k]
          if (['irr_value', 'single_value'].includes(k)) {
            record[k] = !Number.isNaN(Number(value)) && value !== 0 ? value.toFixed(3) * 1 + '%' : value || '-'
          } else if (['policy_cash_grow_rate', 'annuity_year_per_baof'].includes(k)) {
            record[k] = !Number.isNaN(Number(value)) && value !== 0 ? value.toFixed(2) * 1 + '%' : value || '-'
          } else if (k === 'remark') {
            record[k] = record[k] || ''
          } else if (!k.match(/^__/)) {
            record[k] = value || value === 0 ? value : '-'
          }
          if (record[`__${k}__multiple_tag`]) {
            record[`__${k}__color_flag`] = true
          }
          if (!(record.age % 10)) {
            record[`__${k}__bgcolor_flag`] = true
          }
        }
      })

      // 内容转html
      tableBodyData.forEach(record => {
        for (const k in record) {
          record[`__${k}__origin_value`] = record[k]
          if (!k.match(/^__/)) {
            const _purpose_tag = record[`__${k}__purpose_tag`]
            const _multiple_tag = record[`__${k}__multiple_tag`]
            const _interest_ze_tag = record[`__${k}__interest_ze_tag`]
            const _interest_lq_tag = record[`__${k}__interest_lq_tag`]
            const _interest_lj_tag = record[`__${k}__interest_lj_tag`]
            if (_purpose_tag || _multiple_tag || _interest_ze_tag || _interest_lq_tag || _interest_lj_tag) {
              const hasInterestTags = _interest_ze_tag || _interest_lq_tag || _interest_lj_tag
              record[k] = `
                <div class="td_wrapper">
                  <span class="td_content"> ${ record[k] } </span>
                  ${
                    _purpose_tag ? `<span class="purpose_tag">${_purpose_tag}</span>` : ''
                  }
                  ${
                    _purpose_tag && hasInterestTags ? '<br/>' : ''
                  }
                  ${
                    _interest_ze_tag ? `<span class="interest_ze_tag">${_interest_ze_tag}</span>` : ''
                  }
                  ${
                    _interest_lq_tag ? `<span class="interest_lq_tag">${_interest_lq_tag}</span>` : ''
                  }
                  ${
                    _interest_lj_tag ? `<span class="interest_lj_tag">${_interest_lj_tag}</span>` : ''
                  }
                </div>
                ${
                  _multiple_tag ? `<p class="multiple_tag">${_multiple_tag}</p>` : ''
                }
              `
            }
          }
        }
      })
      return tableBodyData
    },
    tableColumnKeys () {
      return Object.keys(this.tableHeaderData).filter(k => !k.match(/^__/))
    },
    tableColumnWidthMap () {
      return this.getTableColumnWidthMap()
    },
    tableWidth () {
      return Object.keys(this.tableColumnWidthMap).reduce((w, k) => w + this.tableColumnWidthMap[k], 0)
    },
  },
  mounted () {
    const self = this
    window.addEventListener('scroll', self.showFixedTabHeader)
    self.autoMoving()
    self.showFixedTabHeader()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', self.showFixedTabHeader)
  },
  methods: {
    caclStringCount (str = '') {
      const ChineseChars = (str + '').match(/[^0-9a-zA-Z.]/g) || ''
      const nonChineseChars = (str + '').match(/[0-9a-zA-Z.]/g) || ''
      return ChineseChars.length + nonChineseChars.length * 0.5
    },
    showFixedTabHeader () {
      const { isAllowScroll, $el } = this
      const interestTableDom = $el
      const interestTableRect = interestTableDom && interestTableDom.getBoundingClientRect()
      const interestNavDom = document.querySelector('.interest_form .header_fixed')
      if (isAllowScroll && interestTableRect) {
        const normalWrapperDom = interestTableDom && interestTableDom.querySelector('.table_wrapper.normal')
        const fixedTopWrapperDom = interestTableDom && interestTableDom.querySelector('.table_wrapper.fixed_top')
        const tableHeaderHeight = interestNavDom ? interestNavDom.clientHeight : 46
        this.isShowFixedTableHeader = interestTableRect.top <= tableHeaderHeight && interestTableRect.bottom >= tableHeaderHeight
        if (this.isShowFixedTableHeader) {
          this.$nextTick(() => {
            fixedTopWrapperDom && (fixedTopWrapperDom.scrollLeft = normalWrapperDom.scrollLeft)
          })
        }
      }
    },
    getTableColumnWidthMap () {
      const { scene, tableColumnKeys, tableHeaderData, tableBodyData, $el } = this
      const textLengthObj = {}
      tableColumnKeys.forEach(k => {
        tableBodyData.forEach((record) => {
          if (record[`__${k}__rowspan`] > 1) {
            return
          }
          const value = record[k] === 0 ? '0' : (record[`__${k}__origin_value`] || '')
          const str = htmlToText.fromString(value)
          const length = this.caclStringCount(str)
          textLengthObj[k] = Math.max((textLengthObj[k] || 0), length)
        })
      })
      const widthList = tableColumnKeys.map(k => ({
        key: k,
        width: textLengthObj[k]
      }))
      widthList.forEach(ele => {
        ele.width += 1.5
        ele.width = Math.max(ele.width, 3)
        const hasMultipleTag = tableBodyData.some(record => record[`__${ele.key}__multiple_tag`])
        const hasPurposeTag = tableBodyData.some(record => record[`__${ele.key}__purpose_tag`])
        const hasInterestZeTag = tableBodyData.some(record => record[`__${ele.key}__interest_ze_tag`])
        const hasInterestLqTag = tableBodyData.some(record => record[`__${ele.key}__interest_lq_tag`])
        const hasInterestLjTag = tableBodyData.some(record => record[`__${ele.key}__interest_lj_tag`])
        const purposeTagStrCount = tableBodyData.reduce((num, record) => Math.max(num, this.caclStringCount(record[`__${ele.key}__purpose_tag`])), 0)
        if (hasMultipleTag) {
          ele.width = Math.max(ele.width, 6) + 1.5
        }
        if (hasPurposeTag) {
          ele.width = ele.width + Math.max(3.75, purposeTagStrCount)
        }
        if (hasInterestZeTag || hasInterestLqTag || hasInterestLjTag) {
          ele.width = Math.max(ele.width, 6)
        }
        if (scene !== 'export') {
          const hasProblemIcon = _get(tableHeaderData, `__${ele.key}__problem_icon`)
          if (hasProblemIcon) {
            ele.width += 1.5
          }
          const hasEyeIcon = ['irr_value', 'single_value'].includes(ele.key)
          if (hasEyeIcon) {
            ele.width += 1.5
          }
        }
        if (ele.key === 'remark') {
          ele.width = 9
        }
        ele.width = Math.min(ele.width, 9)
      })

      // 原生字体大小缩放
      let fontSizeZoom = 1
      const baseFontSize = 14
      const appEl = document.getElementById('app')
      const appFontSize = appEl && !familyId ? parseFloat(getComputedStyle(appEl).fontSize) : 14
      if (typeof appFontSize === 'number') {
        fontSizeZoom = Math.max(fontSizeZoom, appFontSize / baseFontSize)
      }
      widthList.forEach(ele => {
        ele.width *= fontSizeZoom
      })

      // 表格实际宽度小屏宽时，除年度、年龄外的列均分剩于宽度
      const tableWidth = widthList.reduce((w, ele) => w + ele.width, 0)
      let minTableWidth = window.innerWidth
      const tableBodyDom = $el && $el.querySelector('.normal_table_main')
      if (tableBodyDom) {
        minTableWidth = tableBodyDom.clientWidth
      }
      if (scene === 'export') {
        minTableWidth = Math.min(window.innerWidth * 327 / 375, minTableWidth)
      }
      minTableWidth /= 12
      const surplusWidth = (tableWidth < minTableWidth ? minTableWidth - tableWidth : 0)
      if (surplusWidth) {
        const averageWidth = surplusWidth / (widthList.length - 2)
        let consumeWidth = 0
        widthList.forEach((ele, i, arr) => {
          if (['year', 'age', 'age2'].includes(ele.key)) {
            return
          }
          if (i === arr.length - 1) {
            ele.width += (surplusWidth - consumeWidth)
            return
          }
          ele.width += averageWidth
          consumeWidth += averageWidth
        })
      }

      return widthList.reduce((obj, ele) => {
        obj[ele.key] = ele.width
        return obj
      }, {})
    },
    autoMoving () {
      if (!this.isAllowScroll) {
        return
      }
      if (this.isInvokeAnimation) {
        return
      }
      this.isInvokeAnimation = true

      const $tableWrap = _get(this.$refs, 'table_wrapper_normal[0]')
      const $fixedWrap = _get(this.$refs, 'table_wrapper_fixed_top[0]')
      const animateCallback = (value) => {
        $tableWrap && ($tableWrap.scrollLeft = value)
        $fixedWrap && ($fixedWrap.scrollLeft = value)
      }
      animate({
        pri: 0,
        end: 30,
        duration: 400,
        callback: animateCallback,
        endCallback: () => {
          animate({
            pri: 30,
            end: 0,
            duration: 400,
            callback: animateCallback,
            endCallback: () => {
              this.isInvokeAnimation = false
            }
          })
        }
      })
    },
    onClickOpenExplain (k) {
      if (this.isAllowScroll) {
        const bool = _get(this, `tableHeaderData[__${k}__problem_icon]`) || ''
        if (bool) {
          this.$emit('openExplain')
        }
      }
    },
    onClickEyeIcon (key) {
      if (this.isAllowScroll) {
        const _formValues = _get(this.productFormData, 'formValues')
        if (_formValues.hideFieldsForClient.includes(key)) {
          _formValues.hideFieldsForClient = _formValues.hideFieldsForClient.filter(k => k !== key)
        } else {
          _formValues.hideFieldsForClient.push(key)
        }
        this.$emit('update', {
          hideFieldsForClient: _formValues.hideFieldsForClient
        })

        this.isShowEyeTips = true
        clearTimeout(eyeTimer)
        eyeTimer = setTimeout(() => {
          this.isShowEyeTips = false
        }, 3000)
      }
    },
    handleScroll (name, e) {
      if (['normal', 'fixed_top'].includes(name)) {
        let relatedWrap = null
        if (name === 'normal') {
          relatedWrap = this.$refs['table_wrapper_fixed_top']
        }
        if (name === 'fixed_top') {
          relatedWrap = this.$refs['table_wrapper_normal']
        }
  
        if (relatedWrap && relatedWrap[0] && relatedWrap[0] !== e.target) {
          if (this.skipNextScroll) {
            this.skipNextScroll = false
          } else {
            relatedWrap[0].scrollLeft = e.target.scrollLeft
            this.skipNextScroll = true
          }
        }
      }
    }
  }
}
</script>
<style>
@import './index.css';
</style>
